import { render, staticRenderFns } from "./BackofficeFields.vue?vue&type=template&id=fcc873f4&scoped=true"
import script from "./BackofficeFields.vue?vue&type=script&lang=js"
export * from "./BackofficeFields.vue?vue&type=script&lang=js"
import style0 from "./BackofficeFields.vue?vue&type=style&index=0&id=fcc873f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc873f4",
  null
  
)

export default component.exports